import { useEffect, useState } from "react";
import { onIdTokenChanged } from "firebase/auth";
import { auth } from "../Config/firebase-config";
import { getCurrentSubscriptionStatus } from "../actions/Billing/Paddle";
import { premiumStatusCache } from "./premiumStatusCache";

export { invalidatePremiumStatusCache } from "./premiumStatusCache";

const listeners = new Set<(value: boolean | null) => void>();
let started = false;
// Track the user we've force-refreshed for, so server-set claims (level: "pro")
// are pulled exactly once per login instead of looping on the refresh itself.
let forcedUid: string | null = null;

// One shared auth subscription drives every hook instance, and re-evaluates on
// restore/login/logout so we never cache a stale `false` from before Firebase
// had restored the user.
function start() {
  if (started) return;
  started = true;

  onIdTokenChanged(auth, async (user) => {
    let value = false;
    if (user) {
      const force = forcedUid !== user.uid;
      forcedUid = user.uid;
      try {
        value = (await getCurrentSubscriptionStatus(force)).isPremium;
      } catch {
        value = false;
      }
    } else {
      forcedUid = null;
    }
    premiumStatusCache.value = value;
    listeners.forEach((listener) => listener(value));
  });
}

export function usePremiumStatus(): boolean | null {
  const [isPremium, setIsPremium] = useState<boolean | null>(
    premiumStatusCache.value
  );

  useEffect(() => {
    start();
    listeners.add(setIsPremium);
    setIsPremium(premiumStatusCache.value);
    return () => {
      listeners.delete(setIsPremium);
    };
  }, []);

  return isPremium;
}
